/* eslint-disable no-param-reassign */
const sizesConfig = [
  {
    maxWidth: 1500,
    sizes: `calc(93.333vw - 508px)`,
  },
  {
    maxWidth: 1800,
    sizes: `calc(100vw - 608px)`,
  },
  {
    maxWidth: 2000,
    sizes: `66vw`,
  },
  {
    maxWidth: 2200,
    sizes: `60vw`,
  },
  {
    maxWidth: 2400,
    sizes: `54vw`,
  },
  {
    sizes: `50vw`,
  },
];

const usePDPDesktopHeroSizeProps = () => ({
  sizes: sizesConfig.reduce((acc, { maxWidth, sizes }, idx) => {
    acc += `${maxWidth ? `(max-width: ${maxWidth}px)` : ''} ${sizes}`;
    if (idx < sizesConfig.length - 1) {
      acc += ', ';
    }
    return acc;
  }, ''),
});

export default usePDPDesktopHeroSizeProps;
